module.exports = "/_next/static/images/top-49124e9b7258d4017a627b18296bea83.jpg";